import { styled } from 'baseui';

export const InsignificantText = styled('span', ({ $theme }) => ({
  color: '#97a0c0',
  ...$theme.typography.montserrat,
}));

export default InsignificantText;
